import { status } from './lib/status'
import { trackStatus } from './lib/trackStatus'
import { mediaType, MediaType } from './lib/mediaType'
import { drawerType } from './lib/drawerType'
import { ServiceError } from './lib/serviceErrors'
import { SidePanelTypes } from './lib/sidePanelTypes'
import { realm } from './lib/realm'
import { webcastUrlType } from './lib/webcastUrlType'
import { RouterType, AudienceRouterType, ChannelOverviewRouterType, AnalyticsRouterType } from './lib/routerType'
import { AudienceViewsInADay } from './lib/viewsTypes'
import { SyndicationOuts, Authorisations } from './lib/contentTypes'
import { UserCurrentAccountTypes } from './lib/userTypes'
import { Channel as ChannelType } from './lib/channelType'
import { Webcast as WebcastType } from './lib/webcastType'

import * as slides from './lib/slides'
export * from './lib/status'
export * from './lib/trackStatus'
export * from './lib/mediaType'
export * from './lib/serviceErrors'
export * from './lib/sidePanelTypes'
export * from './lib/realm'

const constants = {
  status,
  trackStatus,
  mediaType,
  ServiceError,
  SidePanelTypes,
  drawerType,
  slides,
  realm,
  webcastUrlType
}

export { status, trackStatus, mediaType, ServiceError, SidePanelTypes, drawerType, slides, realm, webcastUrlType }
export type { RouterType, AudienceViewsInADay, SyndicationOuts, Authorisations, AudienceRouterType, UserCurrentAccountTypes, ChannelOverviewRouterType, ChannelType, WebcastType, AnalyticsRouterType, MediaType }
export default constants
